/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactInfo } from '../models/ContactInfo';
import type { ContactInfoUpdate } from '../models/ContactInfoUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContactsService {

    /**
     * Create Contacts
     * @param requestBody
     * @returns ContactInfoUpdate Successful Response
     * @throws ApiError
     */
    public static createContactsContactsCreatePost(
        requestBody: ContactInfoUpdate,
    ): CancelablePromise<ContactInfoUpdate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contacts/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Contacts
     * @param requestBody
     * @returns ContactInfoUpdate Successful Response
     * @throws ApiError
     */
    public static updateContactsContactsUpdatePut(
        requestBody: ContactInfoUpdate,
    ): CancelablePromise<ContactInfoUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/contacts/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Contacts
     * @returns ContactInfoUpdate Successful Response
     * @throws ApiError
     */
    public static getContactsContactsGetGet(): CancelablePromise<ContactInfoUpdate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contacts/get',
        });
    }

    /**
     * Get All Contacts
     * @returns ContactInfo Successful Response
     * @throws ApiError
     */
    public static getAllContactsContactsGetAllGet(): CancelablePromise<Array<ContactInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contacts/get_all/',
        });
    }

    /**
     * Delete Contacts
     * @param clientOnboardId
     * @returns ContactInfo Successful Response
     * @throws ApiError
     */
    public static deleteContactsContactsDeleteClientOnboardIdDelete(
        clientOnboardId: number,
    ): CancelablePromise<ContactInfo> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/contacts/delete/{client_onboard_id}',
            path: {
                'client_onboard_id': clientOnboardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
